/* ========================================================================
 *  module feedback
 * ========================================================================
*/
FD.FAVORITEVIEW = (function ($, me) {
    'use strict';

    var child = me.FAVORITEVIEW || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_COMMON = '/Common/Common/';

    var PARENT_ELEM = '[data-parent="true"]';

    var FAVORITE_CONTENT = '#SS_FAVORITES_CONTENT';
    var FAVORITE_CONTAINER = '#SS_FAVORITES_LIST';
    var APP_VIEW_LIST = "#POP_APPLICATION";
    var SITE_APPS_LIST = '#SS_APPS_CONTENT';
    var notify;
    
    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        FAVORITE_APP: 10,
        FAVORITE_VIEW: 11,
        DELETE_FAVORITE: 12,
        SORT_FAVORITE: 13
    };

    /* ========================================================================
     *  CRUD Functions
     * ========================================================================
    */

    // Determine which CRUD function should be called and update the bookmark icon
    function setFavoriteViewCRUD(data) {
        if (data.e.hasClass('fa-bookmark-o')) {
            data.e.removeClass('fa-bookmark-o').addClass('fa-bookmark');
            handleUserFavoriteViewAddCRUD(+data.parentid, +data.e.closest('[data-parent]').data('appid'));
        } else {
            data.e.removeClass('fa-bookmark').addClass('fa-bookmark-o');
            handleUserFavoriteViewDeleteCRUD(+data.parentid, +data.e.closest('[data-parent]').data('appid'));
        }
    }


    // Save a view as a favorite
    function handleUserFavoriteViewAddCRUD(viewID, appID) {
        var options = {
            url: URL_COMMON + "HandleUserFavoriteViewAddCRUD",
            params: {
                viewID: viewID,
                appID: appID
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                getFavoriteViewList(true);
                var viewLinkInAppList = $(APP_VIEW_LIST).find('[data-parentid="' + viewID + '"]');
                if (viewLinkInAppList.length > 0) {
                    viewLinkInAppList.find('.fa-bookmark-o').removeClass('fa-bookmark-o').addClass('fa-bookmark');
                }
            } else {
                notify = notify || new Notify();
                notify.alert("An error occurred while trying to save this page as a favorite.");
            }
        }
    }


    // Remove a view from the favorites list
    function handleUserFavoriteViewDeleteCRUD(viewID, appID) {
        var options = {
            url: URL_COMMON + "HandleUserFavoriteViewDeleteCRUD",
            params: {
                viewID: viewID,
                appID: appID
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                getFavoriteViewList(true);
                $(APP_VIEW_LIST).find('[data-parentid="' + viewID + '"] .fa-bookmark').removeClass('fa-bookmark').addClass('fa-bookmark-o');
                $(SS_APPS_CONTENT).find('[data-parentid="' + viewID + '"][data-appid="' + appID + '"] .fa-bookmark').removeClass('fa-bookmark').addClass('fa-bookmark-o');
            } else {
                notify = notify || new Notify();
                notify.alert("An error occurred while trying to remove this page from your list of favorites.");
            }
        }
    }


    // Reorder the user's favorite views
    function handleUserFavoriteViewOrderCRUD(data) {
        var viewOrderList = [];
        $(FAVORITE_CONTENT).find('[data-parent]').each(function (index, elem) {
            viewOrderList.push({
                ViewID: $(this).data('parentid'),
                ApplicationID: $(this).data('appid'),
                OrderBy: index
            });
        });
        var options = {
            url: URL_COMMON + "HandleUserFavoriteViewOrderCRUD",
            params: {
                viewList: viewOrderList
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (!result) {
                notify = notify || new Notify();
                notify.alert("An error occurred while trying to reorder your favorites list.");
            }
        }
    }



    /* ========================================================================
     *  View Functions
     * ========================================================================
    */

    function getFavoriteViewList(showLoader) {
        var options = {
            url: URL_COMMON + 'GetFavoriteViewList',
            params: {},
            callback: afterData,
            ishtml: true,
            isloader: showLoader || false
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                var container = $(FAVORITE_CONTENT);
                if (container.length > 0) {
                    container.html(result);
                    me.CONTROL.setButton(true, FAVORITE_CONTAINER);
                    me.CONTROL.setSortable(FAVORITE_CONTAINER);
                }
            } else {
                notify = notify || new Notify();
                notify.alert("An error occurred while trying to refresh the list of your favorite pages.");
            }
        }
    }

    /* ========================================================================
     *  page init
     * ========================================================================
    */


    child.init = function () { };



    //   after control event
    child.getAfterControlEvent = function (data) {
        var result = data;

        switch (data.tag) {
            case tag.FAVORITE_APP:
            case tag.FAVORITE_VIEW:
            case tag.DELETE_FAVORITE:
                setFavoriteViewCRUD(result);
                break;
            case tag.SORT_FAVORITE:
                handleUserFavoriteViewOrderCRUD(result);
                break;
        }
    };

    return child;
}(jQuery, FD));



